"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: referral/referral-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Freferral%2Freferral-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralServiceClient = exports.GetReferralInvitesCountResponse = exports.GetReferralInvitesCountRequest = exports.GetRedemptionsResponse = exports.GetRedemptionsRequest = exports.GetPendingInvitesResponse = exports.GetPendingInvitesRequest = exports.GetReferralInvitesResponse = exports.GetReferralInvitesRequest = exports.RedeemReferralCodeResponse = exports.RedeemReferralCodeRequest = exports.SendReferralInviteResponse = exports.SendReferralInviteRequest = exports.TrackReferralInviteResponse = exports.TrackReferralInviteRequest = exports.VerifyReferralInviteResponse = exports.VerifyReferralInviteRequest = exports.GetStepSquadRewardsResponse = exports.GetStepSquadRewardsRequest = exports.GetReferralStateResponse = exports.GetReferralStateRequest = exports.MigrateResponse = exports.MigrateRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const alias_1 = require("../common/alias");
const referral_invite_status_1 = require("../common/referral-invite-status");
const paging_1 = require("../paging/paging");
const referral_1 = require("./referral");
const referral_campaign_1 = require("./referral-campaign");
const referral_state_1 = require("./referral-state");
const protobufPackage = 'com.step.referral.proto';
function createBaseMigrateRequest() {
    return {};
}
exports.MigrateRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MigrateRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMigrateRequest();
        return message;
    },
};
function createBaseMigrateResponse() {
    return { migrated: false };
}
exports.MigrateResponse = {
    fromJSON(object) {
        const message = {
            migrated: isSet(object.migrated) ? globalThis.Boolean(object.migrated) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.migrated !== false) {
            obj.migrated = message.migrated;
        }
        return obj;
    },
    create(base) {
        return exports.MigrateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMigrateResponse();
        message.migrated = object.migrated ?? false;
        return message;
    },
};
function createBaseGetReferralStateRequest() {
    return {};
}
exports.GetReferralStateRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetReferralStateRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetReferralStateRequest();
        return message;
    },
};
function createBaseGetReferralStateResponse() {
    return {
        referrer: referral_state_1.ReferrerState.fromPartial({}),
        redeemer: undefined,
        redemptionRewardWindow: referral_state_1.RedemptionRewardWindow.fromPartial({}),
    };
}
exports.GetReferralStateResponse = {
    fromJSON(object) {
        const message = {
            referrer: isSet(object.referrer)
                ? referral_state_1.ReferrerState.fromJSON(object.referrer)
                : referral_state_1.ReferrerState.fromPartial({}),
            redemptionRewardWindow: isSet(object.redemptionRewardWindow)
                ? referral_state_1.RedemptionRewardWindow.fromJSON(object.redemptionRewardWindow)
                : referral_state_1.RedemptionRewardWindow.fromPartial({}),
        };
        if (isSet(object.redeemer)) {
            message.redeemer = referral_state_1.RedeemerState.fromJSON(object.redeemer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referrer !== undefined) {
            obj.referrer = referral_state_1.ReferrerState.toJSON(message.referrer);
        }
        if (message.redeemer !== undefined) {
            obj.redeemer = referral_state_1.RedeemerState.toJSON(message.redeemer);
        }
        if (message.redemptionRewardWindow !== undefined) {
            obj.redemptionRewardWindow = referral_state_1.RedemptionRewardWindow.toJSON(message.redemptionRewardWindow);
        }
        return obj;
    },
    create(base) {
        return exports.GetReferralStateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetReferralStateResponse();
        message.referrer = (object.referrer !== undefined && object.referrer !== null)
            ? referral_state_1.ReferrerState.fromPartial(object.referrer)
            : referral_state_1.ReferrerState.fromPartial({});
        message.redeemer = (object.redeemer !== undefined && object.redeemer !== null)
            ? referral_state_1.RedeemerState.fromPartial(object.redeemer)
            : undefined;
        message.redemptionRewardWindow =
            (object.redemptionRewardWindow !== undefined && object.redemptionRewardWindow !== null)
                ? referral_state_1.RedemptionRewardWindow.fromPartial(object.redemptionRewardWindow)
                : referral_state_1.RedemptionRewardWindow.fromPartial({});
        return message;
    },
};
function createBaseGetStepSquadRewardsRequest() {
    return {};
}
exports.GetStepSquadRewardsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetStepSquadRewardsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetStepSquadRewardsRequest();
        return message;
    },
};
function createBaseGetStepSquadRewardsResponse() {
    return { rewards: referral_campaign_1.BasicRewards.fromPartial({}) };
}
exports.GetStepSquadRewardsResponse = {
    fromJSON(object) {
        const message = {
            rewards: isSet(object.rewards)
                ? referral_campaign_1.BasicRewards.fromJSON(object.rewards)
                : referral_campaign_1.BasicRewards.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards !== undefined) {
            obj.rewards = referral_campaign_1.BasicRewards.toJSON(message.rewards);
        }
        return obj;
    },
    create(base) {
        return exports.GetStepSquadRewardsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStepSquadRewardsResponse();
        message.rewards = (object.rewards !== undefined && object.rewards !== null)
            ? referral_campaign_1.BasicRewards.fromPartial(object.rewards)
            : referral_campaign_1.BasicRewards.fromPartial({});
        return message;
    },
};
function createBaseVerifyReferralInviteRequest() {
    return { alias: undefined };
}
exports.VerifyReferralInviteRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.alias)) {
            message.alias = alias_1.Alias.fromJSON(object.alias);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.VerifyReferralInviteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerifyReferralInviteRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : undefined;
        return message;
    },
};
function createBaseVerifyReferralInviteResponse() {
    return {};
}
exports.VerifyReferralInviteResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.VerifyReferralInviteResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseVerifyReferralInviteResponse();
        return message;
    },
};
function createBaseTrackReferralInviteRequest() {
    return { alias: undefined };
}
exports.TrackReferralInviteRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.alias)) {
            message.alias = alias_1.Alias.fromJSON(object.alias);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.TrackReferralInviteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTrackReferralInviteRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : undefined;
        return message;
    },
};
function createBaseTrackReferralInviteResponse() {
    return {};
}
exports.TrackReferralInviteResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.TrackReferralInviteResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTrackReferralInviteResponse();
        return message;
    },
};
function createBaseSendReferralInviteRequest() {
    return { alias: alias_1.Alias.fromPartial({}) };
}
exports.SendReferralInviteRequest = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.SendReferralInviteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendReferralInviteRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        return message;
    },
};
function createBaseSendReferralInviteResponse() {
    return {};
}
exports.SendReferralInviteResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendReferralInviteResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendReferralInviteResponse();
        return message;
    },
};
function createBaseRedeemReferralCodeRequest() {
    return { code: '' };
}
exports.RedeemReferralCodeRequest = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemReferralCodeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemReferralCodeRequest();
        message.code = object.code ?? '';
        return message;
    },
};
function createBaseRedeemReferralCodeResponse() {
    return { rewarded: false };
}
exports.RedeemReferralCodeResponse = {
    fromJSON(object) {
        const message = {
            rewarded: isSet(object.rewarded) ? globalThis.Boolean(object.rewarded) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewarded !== false) {
            obj.rewarded = message.rewarded;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemReferralCodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemReferralCodeResponse();
        message.rewarded = object.rewarded ?? false;
        return message;
    },
};
function createBaseGetReferralInvitesRequest() {
    return { status: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS, paging: undefined };
}
exports.GetReferralInvitesRequest = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.status)
                : referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.status = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.status);
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetReferralInvitesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetReferralInvitesRequest();
        message.status = object.status ?? referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetReferralInvitesResponse() {
    return { invites: [], paging: undefined };
}
exports.GetReferralInvitesResponse = {
    fromJSON(object) {
        const message = {
            invites: globalThis.Array.isArray(object?.invites)
                ? object.invites.map((e) => referral_1.ReferralInvite.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.invites?.length) {
            obj.invites = message.invites.map((e) => referral_1.ReferralInvite.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetReferralInvitesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetReferralInvitesResponse();
        message.invites = object.invites?.map((e) => referral_1.ReferralInvite.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetPendingInvitesRequest() {
    return { status: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS, paging: undefined };
}
exports.GetPendingInvitesRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.status)) {
            message.status = (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.status);
        }
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== undefined &&
            message.status !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.status = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.status);
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetPendingInvitesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPendingInvitesRequest();
        message.status = object.status ?? referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetPendingInvitesResponse() {
    return { invites: [], paging: undefined };
}
exports.GetPendingInvitesResponse = {
    fromJSON(object) {
        const message = {
            invites: globalThis.Array.isArray(object?.invites)
                ? object.invites.map((e) => referral_1.ReferralInvite.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.invites?.length) {
            obj.invites = message.invites.map((e) => referral_1.ReferralInvite.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetPendingInvitesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPendingInvitesResponse();
        message.invites = object.invites?.map((e) => referral_1.ReferralInvite.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetRedemptionsRequest() {
    return { status: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS, paging: undefined };
}
exports.GetRedemptionsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.status)) {
            message.status = (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.status);
        }
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== undefined &&
            message.status !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.status = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.status);
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetRedemptionsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRedemptionsRequest();
        message.status = object.status ?? referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetRedemptionsResponse() {
    return { redemptions: [], paging: undefined };
}
exports.GetRedemptionsResponse = {
    fromJSON(object) {
        const message = {
            redemptions: globalThis.Array.isArray(object?.redemptions)
                ? object.redemptions.map((e) => referral_1.ReferralInvite.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.redemptions?.length) {
            obj.redemptions = message.redemptions.map((e) => referral_1.ReferralInvite.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetRedemptionsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRedemptionsResponse();
        message.redemptions = object.redemptions?.map((e) => referral_1.ReferralInvite.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetReferralInvitesCountRequest() {
    return { status: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS };
}
exports.GetReferralInvitesCountRequest = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.status)
                : referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.status = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.GetReferralInvitesCountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetReferralInvitesCountRequest();
        message.status = object.status ?? referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        return message;
    },
};
function createBaseGetReferralInvitesCountResponse() {
    return { count: 0 };
}
exports.GetReferralInvitesCountResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.count)) {
            message.count = globalThis.Number(object.count);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.count !== undefined && message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        return obj;
    },
    create(base) {
        return exports.GetReferralInvitesCountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetReferralInvitesCountResponse();
        message.count = object.count ?? 0;
        return message;
    },
};
class ReferralServiceClient {
    rpc;
    name = 'com.step.referral.proto.ReferralService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/referral';
    methods = [{
            name: 'Migrate',
            requestType: exports.MigrateRequest,
            responseType: exports.MigrateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetReferralState',
            requestType: exports.GetReferralStateRequest,
            responseType: exports.GetReferralStateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetStepSquadRewards',
            requestType: exports.GetStepSquadRewardsRequest,
            responseType: exports.GetStepSquadRewardsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'Redeem',
            requestType: exports.RedeemReferralCodeRequest,
            responseType: exports.RedeemReferralCodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'VerifyReferralInvite',
            requestType: exports.VerifyReferralInviteRequest,
            responseType: exports.VerifyReferralInviteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'TrackReferralInvite',
            requestType: exports.TrackReferralInviteRequest,
            responseType: exports.TrackReferralInviteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'SendReferralInvite',
            requestType: exports.SendReferralInviteRequest,
            responseType: exports.SendReferralInviteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetReferralInvites',
            requestType: exports.GetReferralInvitesRequest,
            responseType: exports.GetReferralInvitesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetPendingInvites',
            requestType: exports.GetPendingInvitesRequest,
            responseType: exports.GetPendingInvitesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetRedemptions',
            requestType: exports.GetRedemptionsRequest,
            responseType: exports.GetRedemptionsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetReferralInvitesCount',
            requestType: exports.GetReferralInvitesCountRequest,
            responseType: exports.GetReferralInvitesCountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    migrate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getReferralState(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getStepSquadRewards(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    redeem(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Verify that an alias is eligible for being sent a referral invite to Step.
     */
    verifyReferralInvite(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Track that a referral invite was sent to the provided alias.
     */
    trackReferralInvite(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Send SMS to referee through the server.
     */
    sendReferralInvite(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a paged list of the referral invites from the user or the redemptions
     * of their referral code for the provided referral invite status.
     */
    getReferralInvites(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a paged list of pending referral invites from the user.
     */
    getPendingInvites(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a paged list of referral redemptions from the user.
     */
    getRedemptions(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get number of referral invites sent from the user
     */
    getReferralInvitesCount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ReferralServiceClient = ReferralServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=referral-service.js.map